import type { ReactNode } from 'react'
import css from './FormPanel.module.css'

interface FormPanelProps {
    children: ReactNode
}

const FormPanel = ({ children }: FormPanelProps) => {
    return (
        <div className={css.panel}>
            {children}
        </div>
    )
}

export default FormPanel
